import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import "../../styles/login.css";
import maleImg from "../../assets/Loginimg/male.png";
import femaleImg from "../../assets/Loginimg/female.png";
import { FiMail, FiEye, FiEyeOff } from "react-icons/fi";
import {
  postWithoutTokenAPI,
  getWithoutTokenAPI,
  putWithTokenAPI,
  getWithTokenAPI,
} from "../../util/Api";
import {
  FiPhone,
  FiLock,
  FiUser,
  FiMapPin,
  FiBook,
  FiPlus,
} from "react-icons/fi";
import { MdOutlineSchool } from "react-icons/md";
import { useDispatch, useSelector } from "react-redux";
import { setAuthData } from "../../store/authSlice";
import { SafeToast } from "../../components/Toast/ShowToast";
import { Country, State, City } from "country-state-city";
import {
  email_login,
  masterdata_create,
  masterdata_list,
  send_otp,
  students_profile,
  verify_otp,
} from "../../util/Apiendpoits";

const animatedComponents = makeAnimated();

const LoginScreen = () => {
  const navigate = useNavigate();
  const [step, setStep] = useState(1);
  const [phoneNumber, setPhoneNumber] = useState("");
  const [otp, setOtp] = useState("");
  const [institutionName, setInstitutionName] = useState("");
  const [selectedState, setSelectedState] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [selectedExams, setSelectedExams] = useState([]);
  const [loading, setLoading] = useState(false);
  const [sendOtpLoading, setSendOtpLoading] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const location = useLocation();
  const AdminScreen =
    location.pathname.includes("/admin/login") ||
    location.pathname.includes("/institutions/login");
  const isAdminLogin = location.pathname === "/admin/login";
  // const isinstitutionsLogin = location.pathname === "/institutions/login";
  const [otpbtn, setOtpBtn] = useState(true);

  // Validation states
  const [errors, setErrors] = useState({});
  const [isPhoneValid, setIsPhoneValid] = useState(false);
  const [isOtpValid, setIsOtpValid] = useState(false);
  const [isInstitutionValid, setIsInstitutionValid] = useState(false);
  const [isStateValid, setIsStateValid] = useState(false);
  const [isDistrictValid, setIsDistrictValid] = useState(false);

  const [stateOptions, setStateOptions] = useState([]);
  const [districtOptions, setDistrictOptions] = useState([]);
  const dispatch = useDispatch();
  const [examOptions, setExamOptions] = useState([]);
  const [showAddInput, setShowAddInput] = useState(false);
  const [newExamValue, setNewExamValue] = useState("");
  const { userId, token } = useSelector((state) => state.auth);

  const [loginTab, setLoginTab] = useState("mobile");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);

  const handleLoginSwitch = () => {
    setLoginTab((prev) => (prev === "mobile" ? "email" : "mobile"));
  };

  useEffect(() => {
    const fetchExamOptions = async () => {
      try {
        // Call your API helper
        const response = await getWithoutTokenAPI(masterdata_list);

        // Use response.data, not result.data
        if (response.statusCode === 200) {
          const options = response.data
            .filter(
              (item) => item.type === "examType" && item.status === "active",
            )
            .map((item) => ({ value: item.code, label: item.value, id: item._id }));

          setExamOptions(options);
        }
      } catch (error) {
        console.error("Error fetching exam options:", error);
      }
    };

    fetchExamOptions();
  }, []);

  useEffect(() => {
    const indianStates = State.getStatesOfCountry("IN");
    const formattedStates = indianStates.map((state) => ({
      value: state.isoCode,
      label: state.name,
    }));
    setStateOptions(formattedStates);
  }, []);

  // 🔹 Validate phone number
  const validatePhone = (value) => {
    const phoneRegex = /^[0-9]{10}$/;
    const isValid = phoneRegex.test(value);
    setIsPhoneValid(isValid);

    setErrors((prev) => ({
      ...prev,
      phoneNumber: isValid ? "" : "Please enter a valid 10-digit phone number",
    }));

    setPhoneNumber(value);
    return isValid;
  };

  // 🔹 Validate OTP
  const validateOtp = (value) => {
    const otpRegex = /^[0-9]{4,6}$/;
    const isValid = otpRegex.test(value);
    setIsOtpValid(isValid);

    setErrors((prev) => ({
      ...prev,
      otp: isValid ? "" : "Enter a valid OTP",
    }));

    setOtp(value);
    return isValid;
  };

  // 🔹 Validate institution name
  const validateInstitution = (value) => {
    const isValid = value.trim().length >= 3;
    setIsInstitutionValid(isValid);

    if (!isValid && value.length > 0) {
      setErrors((prev) => ({
        ...prev,
        institutionName: "Institution name must be at least 3 characters",
      }));
    } else {
      setErrors((prev) => ({ ...prev, institutionName: "" }));
    }

    setInstitutionName(value);
  };

  // 🔹 Handle state selection
  const handleStateChange = (option) => {
    setSelectedState(option);

    // Reset district
    setSelectedDistrict(null);
    setDistrictOptions([]);

    // Validate
    const isValid = option !== null;
    setIsStateValid(isValid);

    if (isValid) {
      setErrors((prev) => ({ ...prev, state: "" }));

      // Load districts for selected state
      const cities = City.getCitiesOfState("IN", option.value);
      const formattedDistricts = cities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setDistrictOptions(formattedDistricts);
    } else {
      setIsStateValid(false);
      setErrors((prev) => ({ ...prev, state: "Please select a state" }));
    }
  };

  // 🔹 Handle district selection
  const handleDistrictChange = (option) => {
    setSelectedDistrict(option);

    // Validate
    const isValid = option !== null;
    setIsDistrictValid(isValid);

    if (!isValid) {
      setErrors((prev) => ({ ...prev, district: "Please select a district" }));
    } else {
      setErrors((prev) => ({ ...prev, district: "" }));
    }
  };

  // 🔹 Handle exams selection (multi-select)
  const handleExamsChange = (selected) => {
    setSelectedExams(selected);

    // Show input if user selects "Add new exam" option
    const addNewOption = selected?.find((item) => item.value === "ADD_NEW");
    setShowAddInput(!!addNewOption);

    const isValid = !selectedExams || selectedExams.length === 0;

    if (!isValid) {
      setErrors((prev) => ({
        ...prev,
        exam: "Please select at least one exam",
      }));
    } else {
      setErrors((prev) => ({ ...prev, exam: "" }));
    }
  };

  const handleAddExam = async () => {
    if (!newExamValue.trim()) return;

    const newExam = {
      code: newExamValue.toUpperCase(),
      value: newExamValue,
      type: "examType",
      status: "active",
    };

    try {
      const response = await postWithoutTokenAPI(masterdata_create, newExam);
      if (response.statusCode === 200 || response.statusCode === 201) {
        const option = { value: newExam.code, label: newExam.value };
        setExamOptions((prev) => [...prev, option]);
        setSelectedExams((prev) => [
          ...prev.filter((e) => e.value !== "ADD_NEW"),
          option,
        ]);
        setNewExamValue("");
        setShowAddInput(false);
      } else {
      }
    } catch (error) {
      console.error("Error creating new exam:", error);
    }
  };

  const selectOptions = [
    ...examOptions,
    {
      value: "ADD_NEW",
      label: (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <FiPlus size={16} />
          <span>Add new exam</span>
        </div>
      ),
      isAddNew: true, // 👈 custom flag
    },
  ];

  const selectStyles = {
    control: (base) => ({
      ...base,
      border: "none",
      boxShadow: "none",
      backgroundColor: "transparent",
      width: "100%",
    }),
    container: (base) => ({
      ...base,
      width: "100%",
      flex: 1,
    }),
    valueContainer: (base) => ({
      ...base,
      padding: 0,
    }),
  };

  const [cooldown, setCooldown] = useState(0);
  const cooldownRef = useRef(null);

  useEffect(() => {
    if (cooldown > 0) {
      localStorage.setItem("otpCooldown", cooldown.toString());
      localStorage.setItem("otpSentTime", Date.now().toString());
    } else {
      localStorage.removeItem("otpCooldown");
      localStorage.removeItem("otpSentTime");
    }
  }, [cooldown]);

  const startCooldown = (seconds) => {
    setCooldown(seconds);

    cooldownRef.current = setInterval(() => {
      setCooldown((prev) => {
        if (prev <= 1) {
          clearInterval(cooldownRef.current);
          cooldownRef.current = null;
          localStorage.removeItem("otpCooldown");
          localStorage.removeItem("otpSentTime");
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };


  const handleSendOtp = async (type) => {
    // Check if still in cooldown period
    const valid = validatePhone(phoneNumber);
    if (cooldown > 0) {
      SafeToast.info(`Please wait ${cooldown} seconds before resending OTP`);
      return;
    }

    if (!valid) {
      SafeToast.error("Please enter phone number");
      return;
    }

    const payload = {
      phoneNumber,
      roleType: isAdminLogin ? "superadmin" : "institution_admin",
      loginType: type
    };

    try {
      setSendOtpLoading(true);
      const res = await postWithoutTokenAPI(send_otp, payload);

      if (res?.statusCode === 200) {
        SafeToast.success("OTP sent successfully");
        setOtpBtn(false);

        // Start 30 second cooldown timer
        startCooldown(30);

        if (AdminScreen) {
          setStep(2);
        }
      } else {
        SafeToast.error(res?.message || "Failed to send OTP");
      }
    } catch (err) {
      SafeToast.error(
        err?.response?.data?.message || "Something went wrong. Try again!",
      );
    } finally {
      setSendOtpLoading(false);
    }
  };

  const formatTime = (seconds) => {
    return `${seconds}s`;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePassword = (password) => password.length >= 6;
  const validateStep2 = () => {
    const newErrors = {};

    if (!selectedState) {
      newErrors.state = "Please select a state";
    }

    if (!selectedDistrict) {
      newErrors.district = "Please select a district";
    }

    if (!selectedExams || selectedExams.length === 0) {
      newErrors.exam = "Please select at least one exam";
    }

    setErrors(newErrors);

    // return true if no errors
    return Object.keys(newErrors).length === 0;
  };

  const fetchAdminProfile = async (userId) => {
    const res = await getWithTokenAPI(token, `${students_profile}${userId}`);

    console.log(res, 'resres')
    if (res?.statusCode === 200) {
      setInstitutionName(res.data.nameofInstitution)
    }
  };



  /* 🔹 VERIFY OTP */
  const handleVerifyOtp = async () => {
    if (loginTab === "mobile") {
      const valid = validateOtp(otp);

      if (!valid) {
        SafeToast.error("Please enter a valid OTP");
        return;
      }

      const payload = {
        phoneNumber,
        otp,
        roleType: isAdminLogin ? "superadmin" : "institution_admin",
        nameofInstitution: institutionName,
      };

      try {
        setLoading(true);
        const res = await postWithoutTokenAPI(verify_otp, payload);

        if (res.statusCode === 200) {
          // Dispatch auth data
          dispatch(setAuthData(res.data));
          SafeToast.success("Login Successful");

          if (!AdminScreen) {
            setStep(2);
          }
          else {
          if (res.data.is_institutionForm || isAdminLogin) {
            navigate(isAdminLogin ? "/admin/dashboard" : "/institution/dashboard");
          }
            else {
              navigate("/institutions/signup")
              setStep(2);
              fetchAdminProfile(res?.data?.userId)
            }
          }
        } else {
          SafeToast.error(res?.message || "Invalid OTP");
        }
      } catch (err) {
      } finally {
        setLoading(false);
      }
    } else if (loginTab === "email") {
      setErrors({});
      let emailErr = "",
        passwordErr = "";
      if (!validateEmail(email)) emailErr = "Enter a valid email";
      if (!validatePassword(password))
        passwordErr = "Password must be at least 6 characters";

      if (emailErr || passwordErr) {
        setErrors({
          email: emailErr,
          password: passwordErr,
        });
        return;
      }

      try {
        setLoading(true);
        const payload = {
          email,
          password,
        };
        const res = await postWithoutTokenAPI(email_login, payload);
        if (res.statusCode === 200) {
          dispatch(setAuthData(res.data));
          SafeToast.success("Login Successful");
          navigate(res.data.roleType === "superadmin" ? "/admin/dashboard" : "/institution/dashboard");
        } else {
          SafeToast.error(res?.message || "Invalid credentials");
        }
      } catch (err) {
        SafeToast.error("Something went wrong");
      } finally {
        setLoading(false);
      }
    }
  };

  const handleStep2Submit = async () => {
    try {
      setLoading(true);
      if (!validateStep2()) return;
      if (userId) {
        const examValues = selectedExams.map((exam) => exam.id);
        const updateData = {
          state: selectedState?.value,
          district: selectedDistrict?.value,
          exams: examValues,
          institutionName,
          is_institutionForm: true,
        };

        const res = await putWithTokenAPI(
          token,
          `/user/update/${userId}`,
          updateData,
        );
        if (res?.statusCode === 200) {
          SafeToast.success("Profile completed successfully");
          navigate("/institution/dashboard");
        } else {
          SafeToast.error(res?.message || "Failed to update profile");
        }
      } else {
        SafeToast.error("User not found. Please login again.");
      }
    } catch (err) {
      SafeToast.error("Error updating profile");
    } finally {
      setLoading(false);
    }
  };

  /* 🔹 HANDLE SIGN IN (For non-admin flow) */
  const handleSignIn = async () => {
    // First verify OTP
    await handleVerifyOtp();
  };

  if (AdminScreen) {
    return (
      <div className="page-bg">
        <div className="login-wrapper">
          <div className="form-section">
            <div className="login-card">
              {loginTab === "mobile" && (
                <>
                  <div className="form-group">
                    <label>Phone Number</label>
                    <div className="input-box">
                      <span className="icon">
                        <FiPhone />
                      </span>
                      <input
                        placeholder="Enter Phone Number"
                        value={phoneNumber}
                        type="tel"
                        onChange={(e) => setPhoneNumber(e.target.value)}
                        maxLength={10}
                      />
                      <button
                        className="otp-btn"
                        onClick={() => handleSendOtp("signin")}
                        disabled={sendOtpLoading || cooldown > 0}
                      >
                        {sendOtpLoading
                          ? "SENDING..."
                          : cooldown > 0
                            ? `RESEND ${formatTime(cooldown)}`
                            : "SEND OTP"}
                      </button>
                    </div>
                    {errors.phoneNumber && (
                      <div className="error-message">{errors.phoneNumber}</div>
                    )}
                  </div>

                  <div className="form-   ">
                    <label>OTP</label>
                    <div className="input-box single">
                      <span className="icon">
                        <FiLock />
                      </span>
                      <input
                        placeholder="Enter OTP"
                        value={otp}
                        type="tel"
                        onChange={(e) => setOtp(e.target.value)}
                        maxLength={4}
                        disabled={otpbtn}
                      />
                    </div>
                    {errors.otp && (
                      <div className="error-message">{errors.otp}</div>
                    )}
                  </div>
                </>
              )}
              {loginTab === "email" && (
                <>
                  {/* EMAIL */}
                  <div className="form-group">
                    <label>Email</label>
                    <div className="input-box">
                      <span className="icon">
                        <FiMail />
                      </span>

                      <input
                        type="email"
                        placeholder="Enter Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>

                    {errors.email && (
                      <div className="error-message">{errors.email}</div>
                    )}
                  </div>

                  {/* PASSWORD */}
                  <div className="form-group">
                    <label>Password</label>
                    <div className="input-box single">
                      <span className="icon">
                        <FiLock />
                      </span>

                      <input
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                      />

                      <span
                        className="icon right"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? <FiEyeOff /> : <FiEye />}
                      </span>
                    </div>

                    {errors.password && (
                      <div className="error-message">{errors.password}</div>
                    )}
                  </div>
                </>
              )}

              <button
                className="signin-btn"
                onClick={() => handleVerifyOtp()}
                // disabled={otpbtn || !isPhoneValid || loading}
                disabled={
                  loading ||
                  (loginTab === "mobile" ? otpbtn || !isPhoneValid : false)
                }
              >
                {loading ? "LOGIN..." : "LOGIN"}
              </button>

              {isAdminLogin && (
                <span
                  className="email-login-link-other"
                  onClick={handleLoginSwitch}
                >
                  {loginTab === "mobile"
                    ? "Login with email"
                    : "Login with mobile number"}
                </span>
              )}

              {!isAdminLogin && (
                <div className="email-login-link-registered-div">
                  <p className="email-login-link-registered">
                    Not registered yet?
                  </p>
                  <p
                    className="email-login-link-other"
                    onClick={() => navigate("/institutions/signup")}
                  >
                    Register now
                  </p>
                </div>
              )}
            </div>
          </div>

          {/* RIGHT IMAGE */}
          <div className="image-section">
            <img src={step === 1 ? maleImg : femaleImg} alt="Login Visual" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="page-bg">
      <div className="login-wrapper">
        <div className="form-section">
          <div
            className="login-card"
            style={{
              padding: step === 2 ? "10px 20px" : "36px",
            }}
          >
            {" "}
            {step === 2 && institutionName && (
              <div className="institution-tag">{institutionName}</div>
            )}
            {step === 1 && (
              <>
                <div className="form-group">
                  <label>Phone Number</label>
                  <div className="input-box">
                    <span className="icon">
                      <FiPhone />
                    </span>
                    <input
                      placeholder="Enter Phone Number"
                      value={phoneNumber}
                      type="tel"
                      onChange={(e) => setPhoneNumber(e.target.value)}
                      maxLength={10}
                    />
                    <button
                      className="otp-btn"
                      onClick={() => handleSendOtp("signup")}
                      disabled={sendOtpLoading || cooldown > 0}
                    >
                      {sendOtpLoading
                        ? "SENDING..."
                        : cooldown > 0
                          ? `RESEND ${formatTime(cooldown)}`
                          : "SEND OTP"}
                    </button>
                  </div>
                  {errors.phoneNumber && (
                    <div className="error-message">{errors.phoneNumber}</div>
                  )}
                </div>

                <div className="form-group">
                  <label>OTP</label>
                  <div className="input-box single">
                    <span className="icon">
                      <FiLock />
                    </span>
                    <input
                      placeholder="****"
                      type="tel"
                      value={otp}
                      onChange={(e) => setOtp(e.target.value)}
                      maxLength={4}
                      disabled={otpbtn}
                    />
                  </div>
                  {errors.otp && (
                    <div className="error-message">{errors.otp}</div>
                  )}
                </div>

                <div className="form-group">
                  <label>Name of the Institution</label>
                  <div className="input-box single">
                    <span className="icon">
                      <MdOutlineSchool />
                    </span>
                    <input
                      placeholder="Enter Your Institution Name "
                      value={institutionName}
                      onChange={(e) => validateInstitution(e.target.value)}
                    />
                  </div>
                  {errors.institutionName && (
                    <div className="error-message">
                      {errors.institutionName}
                    </div>
                  )}
                </div>

                <button
                  className="signin-btn"
                  onClick={() => handleSignIn()}
                  disabled={!isPhoneValid || !isInstitutionValid || loading}
                >
                  {loading ? "SIGNING IN..." : "SIGN IN"}
                </button>
              </>
            )}
            {step === 2 && (
              <>
                <div className="form-group" style={{ marginTop: "55px" }}>
                  <label>State</label>
                  <div className="select-container">
                    <span className="icon">
                      <FiMapPin />
                    </span>
                    <Select
                      options={stateOptions}
                      classNamePrefix="select"
                      value={selectedState}
                      onChange={handleStateChange}
                      placeholder="Search or select state..."
                      isClearable
                      isSearchable
                      components={animatedComponents}
                      className="react-select"
                      styles={selectStyles}
                    />
                  </div>
                  {errors.state && (
                    <div className="error-message">{errors.state}</div>
                  )}
                </div>

                <div className="form-group">
                  <label>District</label>
                  <div className=" select-container">
                    <span className="icon">
                      <FiMapPin />
                    </span>
                    <Select
                      options={districtOptions}
                      value={selectedDistrict}
                      classNamePrefix="select"
                      onChange={handleDistrictChange}
                      placeholder="Search or select district..."
                      isClearable
                      isSearchable
                      isDisabled={!selectedState}
                      components={animatedComponents}
                      className="react-select"
                      styles={selectStyles}
                    />
                  </div>
                  {errors.district && (
                    <div className="error-message">{errors.district}</div>
                  )}
                </div>

                <div className="form-group">
                  <label>Exams (You can select multiple)</label>
                  <div className="select-container">
                    <span className="icon">
                      <FiBook />
                    </span>
                    {!showAddInput && (
                      <Select
                        options={selectOptions}
                        value={selectedExams}
                        classNamePrefix="select"
                        onChange={handleExamsChange}
                        placeholder="Search and select exams..."
                        isMulti
                        isClearable
                        isSearchable
                        closeMenuOnSelect={false}
                        className="react-select"
                        styles={selectStyles}
                      />
                    )}

                    {showAddInput && (
                      <div className="input-box single">
                        <input
                          type="text"
                          value={newExamValue}
                          onChange={(e) => setNewExamValue(e.target.value)}
                          placeholder="Enter new exam"
                        />
                        <button
                          type="button"
                          onClick={handleAddExam}
                          style={{
                            padding: "8px 16px",
                            backgroundColor: "#4f46e5", // Indigo 600
                            color: "#fff",
                            fontWeight: "500",
                            border: "none",
                            borderRadius: "6px",
                            cursor: "pointer",
                            transition: "background-color 0.2s",
                          }}
                          onMouseOver={(e) =>
                            (e.currentTarget.style.backgroundColor = "#4338ca")
                          } // Indigo 700 hover
                          onMouseOut={(e) =>
                            (e.currentTarget.style.backgroundColor = "#4f46e5")
                          }
                        >
                          Add
                        </button>
                      </div>
                    )}
                  </div>
                  {errors.exam && (
                    <div className="error-message">{errors.exam}</div>
                  )}
                </div>

                <button
                  className="signin-btn"
                  onClick={handleStep2Submit}
                  disabled={loading}
                >
                  {loading ? "UPDATING..." : "LET'S GO"}
                </button>
              </>
            )}
            {!isAdminLogin && (
              <div className="email-login-link-registered-div">
                <p className="email-login-link-registered">
                  Already registered?
                </p>
                <p
                  className="email-login-link-other"
                  onClick={() => navigate("/institutions/login")}
                >
                  Login here
                </p>
              </div>
            )}
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="image-section">
          <img src={step === 1 ? maleImg : femaleImg} alt="Login Visual" />
          <div className="image-overlay">
            <h2>TRUE EXAMS</h2>
            <div className="progress-bar">
              <span
                className={`progress-half left ${step === 1 ? "active" : ""}`}
              ></span>
              <span
                className={`progress-half right ${step === 2 ? "active" : ""}`}
              ></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LoginScreen;
